import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Select from "react-select";
import CommonFooter from "../../../core/common/footer/commonFooter";
import Table from "../../../core/pagination/datatable";
import { API_BASE_URL } from "../Config/Config";
import { Spin } from "antd";
import axios from "axios";
import { DatePicker } from "antd";
import dayjs from "dayjs";
import RefreshIcon from "../../../core/common/tooltip-content/refresh";

const { RangePicker } = DatePicker;

const RawSwipes = () => {
  const [KeyGenarations, setKeyGenarations] = useState([]);

  const [loading, setLoading] = useState(false);
  // const [pagination, setPagination] = useState({
  //   current: 1,
  //   pageSize: 10,
  // });
  const [dateRange, setDateRange] = useState([
    dayjs().subtract(29, "days"),
    dayjs(),
  ]);

  const columns = [
    {
      title: "Super Id",
      dataIndex: "SuperId",
      render: (text) => (
        <span title={text}>
          {text?.length > 15 ? text.substring(0, 15) + "..." : text}
        </span>
      ),
    },
    {
      title: "Serial No",
      dataIndex: "SerialNo",
      render: (text) => (
        <span title={text}>
          {text?.length > 15 ? text.substring(0, 15) + "..." : text}
        </span>
      ),
    },
    {
      title: "RawData",
      dataIndex: "RawData",
      render: (text) => (
        <span title={text}>
          {text?.length > 25 ? text.substring(0, 25) + "..." : text}
        </span>
      ),
    },
    {
      title: "Created",
      dataIndex: "CreatedOn_12hr",
      render: (text) => (
        <span title={text}>
          {text?.length > 20 ? text.substring(0, 20) + "..." : text}
        </span>
      ),
    },
    {
      title: "Updated",
      dataIndex: "UpdatedOn_12hr",
      sorter: (a, b) => a.UpdatedOn_12hr.localeCompare(b.UpdatedOn_12hr),
    },
    {
      title: "Processed",
      dataIndex: "IsProcessed",
      render: (value) => (
        <span className={`badge ${value ? "badge-success" : "badge-danger"}`}>
          {value ? "Yes" : "No"}
        </span>
      ),
      sorter: (a, b) => a.IsProcessed - b.IsProcessed,
    },
    // {
    //   title: "Actions",
    //   render: () => (
    //     <div className="action-icon d-inline-flex align-items-center">
    //       <Link
    //         to="#"
    //         className="me-2 p-2 d-flex align-items-center border rounded"
    //         data-bs-toggle="modal"
    //         data-bs-target="#Notification"
    //       >
    //         <i className="ti ti-bell" />
    //       </Link>
    //     </div>
    //   ),
    // },

    {
      title: "Status",
      dataIndex: "IsActive",
      render: (value) => (
        <span
          style={{
            display: "inline-block",
            width: 15,
            height: 15,
            borderRadius: "50%",
            backgroundColor: value ? "#28a745" : "red",
          }}
        ></span>
      ),
      sorter: (a, b) => a.IsActive - b.IsActive,
    },
  ];

  const getrawswipesbydate = async (start, end) => {
    setLoading(true);
    try {
      const FromDate = start.format("YYYY-MM-DD");
      const ToDate = end.format("YYYY-MM-DD");

      const res = await axios.get(
        `${API_BASE_URL}/api/getrawswipesbydate?FromDate=${FromDate}&ToDate=${ToDate}`
      );

      setKeyGenarations(res.data?.ResultData || []);
    } catch (err) {
      console.error("Error fetching data:", err);
    } finally {
      setLoading(false);
    }
  };

  const handleDateChange = (dates) => {
    if (!dates) return;
    setDateRange(dates);
    getrawswipesbydate(dates[0], dates[1]);
  };

  // Handle Edit Click - Populate Modal (optional enhancement)
  const handleEdit = (record) => {
    // You can set state here to prefill modal if needed
    console.log("Editing getallorgkeygeneration:", record);
  };

  useEffect(() => {
    getrawswipesbydate(dateRange[0], dateRange[1]);
  }, []);

  const handleRefresh = () => {
    window.location.reload();
  };
  return (
    <>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>Raw Swipes</h4>
                <h6>Manage your Raw Swipes</h6>
              </div>
            </div>
            <ul className="table-top-head">
              <li onClick={handleRefresh} style={{ cursor: "pointer" }}>
                <RefreshIcon />
              </li>
            </ul>
          </div>

          <div className="card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3 ">
              <h5 className="mb-3">Raw Swipes List</h5>

              <div className="dropdown me-3">
                <RangePicker
                  value={dateRange}
                  allowClear={false}
                  onChange={handleDateChange}
                  format="MM/DD/YYYY"
                  presets={[
                    {
                      label: "Today",
                      value: [dayjs(), dayjs()],
                    },
                    {
                      label: "This Week",
                      value: [dayjs().startOf("week"), dayjs()],
                    },
                    {
                      label: "This Month",
                      value: [dayjs().startOf("month"), dayjs()],
                    },
                  ]}
                />

                <span className="input-icon-addon">
                  <i className="ti ti-chevron-down" />
                </span>
              </div>
            </div>
            <div className="card-body p-0">
              <div className="table-responsive">
                {loading ? (
                  <div className="text-center my-4">
                    <Spin size="large" />
                    <p>Loading data...</p>
                  </div>
                ) : (
                  <div className="table-responsive">
                    <Table columns={columns} dataSource={KeyGenarations} />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        <CommonFooter />
      </div>
      {/* /Page Wrapper */}
      <div className="modal fade" id="add_plans">
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">New Key Generation</h4>
              <button
                type="button"
                className="btn-close custom-btn-close p-0"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <form>
              <div className="modal-body pb-0">
                <div className="row">
                  <div className="col-md-6">
                    <label className="form-label">Super Id *</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Select Organization"
                    />
                  </div>

                  <div className="col-md-6">
                    <label className="form-label">License Type *</label>
                    <Select
                      classNamePrefix="react-select"
                      options={[
                        { value: "Organization", label: "Organization" },
                        { value: "Individual", label: "Individual" },
                      ]}
                      placeholder="License Type"
                    />
                  </div>

                  <div className="col-md-6">
                    <label className="form-label">Product Type *</label>
                    <Select
                      classNamePrefix="react-select"
                      options={[
                        { value: "product1", label: "Product One" },
                        { value: "product2", label: "Product Two" },
                      ]}
                      placeholder="Select Product"
                    />
                  </div>

                  <div className="col-md-6">
                    <label className="form-label">Store ID / Branch ID *</label>
                    <input
                      type="number"
                      className="form-control"
                      placeholder="0"
                    />
                  </div>

                  <div className="col-md-6">
                    <label className="form-label">
                      Terminal ID / Machine ID *
                    </label>
                    <input
                      type="number"
                      className="form-control"
                      placeholder="0"
                    />
                  </div>

                  <div className="col-md-6">
                    <label className="form-label">MAC / Serial No *</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter MAC / Serial No"
                    />
                  </div>

                  <div className="col-md-6">
                    <label className="form-label">Next Renewal *</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="DD-MM-YYYY"
                    />
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-light me-2"
                  data-bs-dismiss="modal"
                >
                  Cancel
                </button>
                <Link
                  to="button"
                  data-bs-dismiss="modal"
                  className="btn btn-primary"
                >
                  Save
                </Link>
              </div>
            </form>
          </div>
        </div>
      </div>
      {/* Edit Plan */}
      <div className="modal fade" id="edit_organization">
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">Edit Organization</h4>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
              ></button>
            </div>
            <div className="modal-body">
              <form>
                <div className="row">
                  <div className="col-md-6 mb-3">
                    <label className="form-label">MAC / Serial No</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter MAC / Serial No"
                    />
                  </div>

                  <div className="col-md-6 mb-3">
                    <label className="form-label">
                      Terminal ID / Machine ID
                    </label>
                    <input
                      type="number"
                      className="form-control"
                      placeholder="0"
                    />
                  </div>

                  <div className="col-md-6 mb-3">
                    <label className="form-label">Store ID / Branch ID</label>
                    <input
                      type="number"
                      className="form-control"
                      placeholder="0"
                    />
                  </div>

                  <div className="col-md-6 mb-3">
                    <label className="form-label">Next Renewal Date</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="DD-MM-YYYY"
                    />
                  </div>
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-light me-2"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary"
                    data-bs-dismiss="modal"
                    onClick={handleEdit}
                  >
                    Update Client
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      {/* /Edit Plan */}
      <div className="modal fade" id="Notification">
        <div className="modal-dialog modal-dialog-centered modal-xl">
          <div className="modal-content">
            <div className="modal-header">
              <h3 className="text-gray-9 fw-medium">
                Data Not Received For BrightWave Innovations
              </h3>
              <button
                type="button"
                className="btn-close custom-btn-close p-0"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <div className="modal-body">
              <div className="row">
                <div className="col-md-3">
                  <div className="mb-3">
                    <label className=" fw-medium">Client</label>
                    <input type="text" className="form-control" />
                  </div>
                </div>

                <div className="col-md-3">
                  <div className="mb-3">
                    <label className=" fw-medium">Subject</label>
                    <input type="text" className="form-control" />
                  </div>
                </div>

                <div className="col-md-3">
                  <div className="mb-3">
                    <label className="fw-medium">Email To</label>
                    <input type="email" className="form-control" />
                  </div>
                </div>

                <div className="col-md-3">
                  <div className="mb-3">
                    <label className="fw-medium">Contact</label>
                    <input type="text" className="form-control" />
                  </div>
                </div>

                <div className="col-md-8">
                  <div className="mb-3">
                    <label className="fw-medium">Notify Message Content</label>
                    <textarea className="form-control" rows="5"></textarea>
                  </div>
                </div>

                <div className="text-center">
                  <button className="btn btn-success text-white">Notify</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default RawSwipes;
